import { render, staticRenderFns } from "./PromocodesPage.vue?vue&type=template&id=4ac2d8ec&scoped=true"
import script from "./PromocodesPage.vue?vue&type=script&lang=js"
export * from "./PromocodesPage.vue?vue&type=script&lang=js"
import style0 from "./PromocodesPage.vue?vue&type=style&index=0&id=4ac2d8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac2d8ec",
  null
  
)

export default component.exports